import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../../static/constants'

import { SettingsSidebar } from '../../organisms'

interface IProps {
  user: any
  active_path: string
  children: React.ReactNode
  backgroundColor?: 'default' | 'white'
}

const SettingsLayout: React.VFC<IProps> = ({ active_path, user, children, backgroundColor }) => {
  return (
    <Wrapper>
      <SettingsSidebar active={active_path} user={user} backgroundColor={backgroundColor} />
      <Main backgroundColor={backgroundColor}>{children}</Main>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  margin: 0 auto;
  min-height: calc(100vh - ${constants.HEADER_HEIGHT + constants.FOOTER_HEIGHT}px);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
    flex-direction: column;
  }
`

const Main = styled.div`
  flex: 1;
  padding: 16px;
  min-height: calc(100vh - ${constants.HEADER_HEIGHT + constants.FOOTER_HEIGHT}px);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  background-color: ${({ backgroundColor }) =>
    backgroundColor === 'white' ? constants.COLORS.white : constants.COLORS.background};

  @media (max-width: ${constants.BREAKPOINT_DESKTOP}px) {
    padding-top: ${({ backgroundColor }) => (backgroundColor === 'white' ? '16px' : '55px')};
  }
  @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
    padding: 16px;
    background-color: ${constants.COLORS.white};
  }
`

export default SettingsLayout
